export default {
  labels: {
    google_place: 'Google-sijainti',
    menu_import: 'Ruokalistan tuonti',
    live: 'Live',
    setting_up: 'Käyttöönotossa',
  },
  buttons: {
    confirm: 'Vahvista',
    cancel: 'Peruuta',
    continue_setup: 'Jatka asennusta',
  },
  delete_confirmation: 'Oletko varma?',
};
